/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from '@ngrx/store';
import { BrowseClickSuccess, GetReturnCodeAfterExportSuccess, GetVisibleInvisibleSystemsSuccess } from './system-manager-actions';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { SystemManagerExportReturnCodes } from '../../../../../../shared/ui/src/lib/enums/system-manager-export-return-codes';

export const SystemManagerKey = 'SystemManager';

export interface SystemManagerState {
  visibleInvisibleSystems?: SystemInfo[];
  returnCodeExport?: SystemManagerExportReturnCodes;
  fileName?: string;
}

export const initialSystemManagerState: SystemManagerState = {
  visibleInvisibleSystems: [],
  returnCodeExport: SystemManagerExportReturnCodes.Success,
  fileName: 'initial file name'
};

export const SystemManagerReducer = createReducer(
  initialSystemManagerState,

  on(GetVisibleInvisibleSystemsSuccess, (state, action) => {
    return {
      ...state,
      visibleInvisibleSystems: action.visibleInvisibleSystems
    };
  }),

  on(GetReturnCodeAfterExportSuccess, (state, action) => {
    return {
      ...state,
      returnCodeExport: action.returnCodeExport
    };
  }),

  on(BrowseClickSuccess, (state, action) => {
    return {
      ...state,
      fileName: action.response,
    };
  })
);
